<div #treiberCreateModal class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button *ngIf="!isSending" type="button" class="close" (click)="close()" aria-label="Close"><span
          aria-hidden="true">&times;</span>
        </button>
        <h3 class="modal-title">{{ 'adura.driver.new' | translate }}</h3>
      </div>
      <form [formGroup]="treiberCreateForm" (ngSubmit)="onSubmit()">
        <div class="modal-body">
          <p *ngIf="error" class="alert alert-danger" role="alert"> {{ errorMessage | translate }}</p>
          <div class="form-group">
            <label for="bezeichnungEn">{{ 'adura.stammdaten.bezeichnung.en' | translate }}:</label>
            <span class="length-counter-modal">
              {{ (255 - treiberCreateForm.get('bezeichnungEn').value?.length) + ' / 255' }}
            </span>
            <input
              type="text"
              class="form-control"
              formControlName="bezeichnungEn"
              id="bezeichnungEn"
              maxlength="255"
              autocomplete="off">
          </div>
          <div class="form-group">
            <label for="bezeichnungDe">{{ 'adura.stammdaten.bezeichnung.de' | translate }}:</label>
            <span class="length-counter-modal">
              {{ (255 - treiberCreateForm.get('bezeichnungDe').value?.length) + ' / 255' }}
            </span>
            <input
              type="text"
              class="form-control"
              formControlName="bezeichnungDe"
              id="bezeichnungDe"
              maxlength="255"
              autocomplete="off">
          </div>
          <div class="form-group">
            <label for="bezeichnungFr">{{ 'adura.stammdaten.bezeichnung.fr' | translate }}:</label>
            <span class="length-counter-modal">
              {{ (255 - treiberCreateForm.get('bezeichnungFr').value?.length) + ' / 255' }}
            </span>
            <input
              type="text"
              class="form-control"
              formControlName="bezeichnungFr"
              id="bezeichnungFr"
              maxlength="255"
              autocomplete="off">
          </div>
          <div class="form-group">
            <label for="bezeichnungIt">{{ 'adura.stammdaten.bezeichnung.it' | translate }}:</label>
            <span class="length-counter-modal">
              {{ (255 - treiberCreateForm.get('bezeichnungIt').value?.length) + ' / 255' }}
            </span>
            <input
              type="text"
              class="form-control"
              formControlName="bezeichnungIt"
              id="bezeichnungIt"
              maxlength="255"
              autocomplete="off">
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary" (click)="close()">
            {{ 'global.cancel' | translate }}
          </button>
          <button type="submit" class="btn btn-sm btn-space btn-primary"
                  [disabled]="treiberCreateForm.invalid || this.isSending">
            <i *ngIf="isSending" class="fa fa-spinner fa-pulse fa-fw"></i>{{ 'global.save' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
